import { render } from "./page-2.6.vue?vue&type=template&id=5844484b&scoped=true"
import script from "./page-2.6.vue?vue&type=script&lang=js"
export * from "./page-2.6.vue?vue&type=script&lang=js"

import "./page-2.6.vue?vue&type=style&index=0&id=5844484b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5844484b"]])

export default __exports__